/* eslint-disable react/jsx-key */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import './top-bar-action-entity-icons.scss';
import { getEntitiesListConfig } from '@constants/config';
import { downloadCSVFromURL } from '@actions/data-table-actions';
import ExportButton from '@shared/export-button';
import { BASE_URL } from '@constants/endpoints';

const TopBarActionGroupIcons = () => {
  const dispatch = useDispatch();

  const { data } = useSelector(state => state.dataDetail);
  const { groupType, id } = useParams();

  const downloadCSV = entityType => {
    const url = `${BASE_URL}/be/group/export_csv/${entityType}/${id}/`;
    const filename = `group-${groupType}-${id}-${entityType}.csv`;
    dispatch(downloadCSVFromURL(url, filename, 'group'));
  };

  const exportCSV = () => {
    if (data.entities.length > 0) {
      getEntitiesListConfig().forEach(entity => {
        const found = data.entities.find(groupEntity => groupEntity.type_name === entity);
        if (found) {
          downloadCSV(entity);
        }
      });
    }
  };

  if (id) {
    return [
      <ExportButton onClick={exportCSV} />
    ];
  }
  return null;
};

export default TopBarActionGroupIcons;
